var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Kuro_Logo",
    "data-name": "Kuro Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.117,
    height: 155.536,
    viewBox: "0 0 144.117 155.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M.038,20.861C1.324,18.5,22.922-1.091,24.744-.925s-11.08,140.012-12.2,144.08S-4.344,160.189-5.391,158.966-1.247,23.22.038,20.861Z",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 81.944, 3.49)",
    fill: "#0a3258"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1.318,14.695c1.183-2.5,25.066-7,25.066-7S54.627,2.03,57.049,2.6s8.74,9.911,6.965,11.244-38.93,7.542-41.7,15.56S18.937,80.16,18.142,80.356,3.717,61.212,3.339,59.539.135,17.192,1.318,14.695Z",
    transform: "translate(42.026 98.448) rotate(-44)",
    fill: "#0a3258"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroLogo);
export default __webpack_public_path__ + "static/media/Asset-KuroLogo.23fbfa2988e745627461759e280312a9.svg";
export { ForwardRef as ReactComponent };